import React from 'react';
import { Row, CardBody } from 'reactstrap';
import { Bar } from 'react-chartjs-2';
import {
  BaseCardChartContainer,
  BaseChartCardHeaderContainer,
  BaseChartContainer,
  BaseColContainer
} from './common-charts-styles';

export function ProtocolsPerServiceChannel({ data }) {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        data: data.data,
        backgroundColor: data.backgroundColor
      }
    ]
  };

  const options = {
    indexAxis: 'y',
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          stepSize: 5
        }
      }
    },
    responsive: true,
    maintainAspectRatio: true
  };

  return (
    <BaseCardChartContainer>
      <BaseChartCardHeaderContainer>
        <h5 className="h3 mb-0">Protocolos por Canal de Serviço</h5>
      </BaseChartCardHeaderContainer>
      <CardBody>
        <Row>
          <BaseColContainer>
            <BaseChartContainer className="chart" style={{ height: '100%' }}>
              <Bar data={chartData} options={options} />
            </BaseChartContainer>
          </BaseColContainer>
        </Row>
      </CardBody>
    </BaseCardChartContainer>
  );
}
